angular
	.module('AutoPrequal')
	.controller('downPaymentCtrl', downPaymentCtrl);

downPaymentCtrl.$inject = ['$scope', '$rootScope', '$state', 'ScrollFactory', 'SubmitFactory', 'DataFactory'];

function downPaymentCtrl($scope, $rootScope, $state, ScrollFactory, SubmitFactory, DataFactory) {

	$rootScope.progressCurrent = 15;
	$rootScope.progressMobCurrent = 15;

	$scope.content = DataFactory.appData.content;
	$scope.localContent = DataFactory.appData.content.downPayment;

	$scope.data = DataFactory.appData.applicant;

	$rootScope.downPaymentNextStep = function () {
		if ($scope.DownPayment.$valid) {

			attachGAClientId();

			DataFactory.appData.applicant.appState.downPayment = true;

			$scope.data.apDownPayment = $scope.data.apDownPayment ? $scope.data.apDownPayment : 0;

			DataFactory.setData($scope.data).then(function (result) {
				SubmitFactory.submit($scope.data.sessionId).then(function (response) {
					DataFactory.appData.submit = response.result_content;
					if ($scope.data.profileUpdated) {
						DataFactory.appData.submit.profileUpdated = true;
					}
					$state.go('results');
				});
			});
		}
		else {
			angular.forEach($scope.DownPayment.$error, function (field) {
				angular.forEach(field, function (errorField, index) {
					errorField.$setTouched();
					$rootScope.errorNumber = index + 1;
				})
			});
		}
	}

	$scope.prevStep = function () {
		if ($scope.data.hasTradein === "Yes") {
			ScrollFactory.showStep("tradeinPayments");
			ScrollFactory.goToStep("tradeinPayments");
		}
		else {
			ScrollFactory.showStep("tradein");
			ScrollFactory.goToStep("tradein");
		}
	}

	function attachGAClientId() {
        var gaClientId = '';
        if (typeof ga !== "undefined" && ga && ga.getAll) {
            var trackers = ga.getAll();
            for (var i = 0; i < trackers.length; i++) {
                var tracker = trackers[i];
                gaClientId = tracker.get('clientId');
            }
        } else if (env == 'DEV') {
            gaClientId = '123.123';
        }
        $scope.data.gaClientId = gaClientId;
    }
}
